<template>
    <div>
        <video :id="tcPlayerId" class="tencent-player" preload="auto" :controlBar="{volumePanel:false}" playsinline webkit-playsinline  ></video>
    </div>
</template>
<script>

export default {
    name: 'TencentPlayer',
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    mounted() {
        this.loadJS();
    },
    data() {
        return {
            tcPlayerId : 'tcPlayer' + Date.now(),
            player: null,
            videoHigh:"200px"
        };
    },
    watch: {
        options: {
            handler(newV, oldV) {
                this.$nextTick(() => {
                    console.log("newV ==",newV)
                    this.player&&this.player.dispose();
                    
                });
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
         loadTcScript(cb) {
             console.log("come here 333")
            this.loadScript(cb, {
                id: 'tcPlayerScriptId',
                url: '/static/tcplayer.v4.2.1.min.js',
            });
        },
         loadScript(cb, obj) {
            if (document.getElementById(obj.id)) {
                cb();
            } else {
                console.log("come here 444")
                const script = document.createElement('script');
                script.async = true;
                script.src = obj.url;
                script.id = obj.id;
                script.onload = () => {
                    cb();
                };
                document.body.appendChild(script);
            }
        },
        loadJS() {
            console.log("loadJS")
            if (window.TCPlayer) {
                this.initVideo();
            } else {
                this.loadTcScript(() => {
                    this.initVideo();
                });
            }
        },
        initVideo() {

            setTimeout(() => {
                if (!this.player) {
                    console.log("come here 111")
                    this.player = TCPlayer(this.tcPlayerId, {});
                    this.player.src(this.options.url);
                } else {
                    console.log("come here 222")
                    this.player.src(this.options.url);
                }
            },200);
        }
    },
    beforeDestroy() {
        this.player.dispose()
    }
};
</script>
<style  scoped>
/* @import url("../../assets/tcplayer.min.css"); */
.tencent-player{
    width: 100%;
    height: 100%;
}
</style>